import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createAuth0 } from '@auth0/auth0-vue'
import dayjsPlugin from './plugins/dayjs'
import errorHandler from './plugins/errorHandler'
import logger from './utils/logger'
import './utils/devTools' // Initialize dev tools in development

// Create the Vue application
const app = createApp(App)

// Log application startup
logger.info('Admin Application Starting', {
  environment: process.env.NODE_ENV,
  version: process.env.VUE_APP_VERSION || 'unknown',
  timestamp: new Date().toISOString()
})

// Install error handler plugin first
app.use(errorHandler)

// Configure Auth0
app.use(
  createAuth0({
    domain: process.env.VUE_APP_AUTH0_DOMAIN,
    clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
    authorizationParams: {
      redirect_uri: process.env.VUE_APP_AUTH0_CALLBACK,
      audience: process.env.VUE_APP_AUTH0_AUDIENCE
    },
    cacheLocation: 'localstorage',
    useRefreshTokens: true
  })
)

logger.debug('Auth0 configured', {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  hasAudience: !!process.env.VUE_APP_AUTH0_AUDIENCE
})

// Use the router
app.use(router)

// Use Day.js plugin
app.use(dayjsPlugin)

// Log when app is about to mount
logger.debug('Mounting Vue application to #app')

// Mount the app
app.mount('#app')

// Log successful mount
logger.info('Admin Application Mounted Successfully', {
  userAgent: navigator.userAgent,
  windowSize: {
    width: window.innerWidth,
    height: window.innerHeight
  },
  url: window.location.href
})
